import React from 'react';
import ReactDOM from 'react-dom';
import {
    Provider,
} from 'react-redux';
import makeStore from '@shared/store';
import {
    setLanguage,
} from '@shared/language';
import ViewerApp from './containers/ViewerApp';
import rootSaga from './sagas';

const root = document.getElementById('TourViewer');
if (root) {
    setLanguage(root.dataset.language || 'de');
    ReactDOM.render(
        <Provider
            store={makeStore(rootSaga)}
        >
            <ViewerApp />
        </Provider>,
        root,
    );
}
